import { createSelector } from 'reselect'
import get from 'lodash.get'


export const getMappedObjectsByKey = (list, key, keyMask) => {
  const mappedObjects = {}
  if (list && list.length) {
    list.map((obj, index) => {
      if (keyMask) {
        mappedObjects[keyMask(get(obj, key, index))] = obj
      } else {
        mappedObjects[get(obj, key, index)] = obj
      }
      return obj
    })
  }
  return mappedObjects
}

export const getIncidents = createSelector(
  state => get(state, 'incidents.mappedIncidentsById', {}),
  incidents => incidents,
)

export const getHasMoreIncidents = createSelector(
  state => state.incidents.hasMoreIncidents,
  hasMoreIncidents => hasMoreIncidents,
)
